<ng-container *ngIf="control">
  <label class="esf-form-item__label">{{ label }}<app-optional *ngIf="optional"></app-optional></label>
  <div class="esf-select" controlErrorContainer>
    <select class="esf-form-item__field esf-select__field"
            [formControl]="formControl"
            [id]="id"
            (change)="onChange($event)">
      <ng-content></ng-content>
      <option *ngIf="placeholderText" value="null" hidden>{{ placeholderText }}</option>
      <ng-container *ngIf="!useNgValue">
        <option *ngFor="let element of array" [value]="element[valueKey]">{{ element[textKey] }}</option>
      </ng-container>
      <ng-container *ngIf="useNgValue">
        <option *ngFor="let element of array" [disabled]="element[disabledKey]" [ngValue]="element[valueKey]">{{ element[textKey] }}</option>
      </ng-container>
    </select>
  </div>
</ng-container>

<ng-container *ngIf="!control">
  <label class="esf-form-item__label">{{ label }}<app-optional *ngIf="optional"></app-optional></label>
  <div class="esf-select">
    <select class="esf-form-item__field esf-select__field"
            [id]="id"
            (change)="onChange($event)">
      <ng-content></ng-content>
      <option *ngIf="placeholderText" value="null">{{ placeholderText }}</option>
      <option *ngFor="let element of array" [selected]="element[valueKey] === preselectedValue" [value]="element[valueKey]">{{ lodash.get(element, textKey) }}</option>
    </select>
  </div>
</ng-container>
